
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contest/[contestUuid]/detail",
      function () {
        return require("private-next-pages/contest/[contestUuid]/detail.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/contest/[contestUuid]/detail"])
      });
    }
  